import { useMutation } from '@tanstack/react-query'

import type {
  BookingSpecificityDetail,
  CreateBookingSpecificityPayload,
} from '../../types/booking-specificity.js'

import { apiClient } from '../../lib/client.js'

export const useCreateBookingSpecificityMutation = () => {
  return useMutation({
    mutationFn: async ({
      bookingId,
      ...data
    }: CreateBookingSpecificityPayload & { bookingId: string }) => {
      const response = await apiClient.client.post<BookingSpecificityDetail>(
        `/me/bookings/${bookingId}/specificity`,
        data
      )
      return response.data
    },
  })
}
